module.exports = __webpack_public_path__ + "static/media/deleteIcon1.6f01eb8c.svg";